import { jsx } from "react/jsx-runtime";
import { createContext, useState, useContext } from "react";
const SubtitleTrackContext = createContext(
  /** @type {SubtitleTrackId} */
  ""
);
SubtitleTrackContext.displayName = "SubtitleTrackContext";
function useSubtitleTrack() {
  const subtitleTrack = useContext(SubtitleTrackContext);
  return subtitleTrack;
}
const SetSubtitleTrackContext = createContext(
  /** @type {React.Dispatch<React.SetStateAction<SubtitleTrackId>> | undefined} */
  void 0
);
SetSubtitleTrackContext.displayName = "SetSubtitleTrackContext";
function useSetSubtitleTrack() {
  const setSubtitleTrack = useContext(SetSubtitleTrackContext);
  if (!setSubtitleTrack) {
    throw new Error("useSetSubtitleTrack called without a SetSubtitleTrackContext.Provider");
  }
  return setSubtitleTrack;
}
function VideoSubtitleTrackProvider({ children }) {
  const [subtitleTrack, setSubtitleTrack] = useState(
    /** @type {SubtitleTrackId} */
    ""
  );
  return /* @__PURE__ */jsx(SetSubtitleTrackContext.Provider, { value: setSubtitleTrack, children: /* @__PURE__ */jsx(SubtitleTrackContext.Provider, { value: subtitleTrack, children }) });
}
export {
  VideoSubtitleTrackProvider,
  useSetSubtitleTrack,
  useSubtitleTrack };
//# sourceMappingURL=dist/components/VideoContextProvider/context/state/subtitleTrack.js.map